
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { ClubCoach } from '@/types/team';

export const useClubCoachData = (clubId?: string) => {
  const [clubCoaches, setClubCoaches] = useState<ClubCoach[]>([]);
  const [coachesLoaded, setCoachesLoaded] = useState(false);

  const fetchClubCoaches = async (targetClubId: string) => {
    if (!targetClubId) {
      setClubCoaches([]);
      setCoachesLoaded(true);
      return;
    }

    try {
      setCoachesLoaded(false);
      
      const { data, error } = await supabase
        .from('club_coaches')
        .select(`
          coach_id,
          profiles!coach_id(id, first_name, last_name)
        `)
        .eq('club_id', targetClubId);

      if (error) throw error;
      
      const coaches = data?.map(item => ({
        id: item.coach_id,
        first_name: item.profiles?.first_name || '',
        last_name: item.profiles?.last_name || ''
      })).filter(coach => coach.first_name || coach.last_name) || [];
      
      setClubCoaches(coaches);
      setCoachesLoaded(true);
    } catch (error) {
      console.error('Error fetching club coaches:', error);
      toast.error('Failed to load club coaches');
      setClubCoaches([]);
      setCoachesLoaded(true);
    }
  };

  useEffect(() => {
    if (clubId) {
      fetchClubCoaches(clubId);
    } else {
      setClubCoaches([]);
      setCoachesLoaded(true);
    }
  }, [clubId]);

  return {
    clubCoaches,
    coachesLoaded,
    fetchClubCoaches
  };
};
